// File: client/src/variants/mayhem/index.js
// Chess Mayhem as a platform plugin.

import rulebook from './rulebook';
import { useMayhemRuntime } from './useMayhemRuntime';

const mayhemVariant = {
  id: 'mayhem',
  name: 'Chess Mayhem',
  tagline: 'Maximum chaos — a random global modifier fires every single turn.',
  icon: '🔥',
  accent: 'from-red-600 to-rose-800',
  supportedGameTypes: ['ai', 'local'],
  order: 6,
  rulebook,
  useRuntime: useMayhemRuntime,
};

export default mayhemVariant;
